
import React from 'react';
import { Product } from '@/lib/supabase/products/types';
import { Button } from '@/components/ui/button';
import { Heart } from 'lucide-react';
import { Separator } from '@/components/ui/separator';
import OrderFormSubmit from './OrderFormSubmit';
import ProductQuantitySelector from './ProductQuantitySelector';

interface ProductOrderSummaryProps {
  product: Product;
  quantity: number;
  totalPrice: number;
  incrementQuantity: () => void;
  decrementQuantity: () => void;
  submitting: boolean;
  inStock: boolean;
  shopColor: string;
  ctaButtonText: string;
  formId?: string | null;
}

const ProductOrderSummary = ({
  product,
  quantity,
  totalPrice,
  incrementQuantity,
  decrementQuantity,
  submitting,
  inStock,
  shopColor,
  ctaButtonText,
  formId
}: ProductOrderSummaryProps) => {
  const actualPrice = product.discount_price || product.price;

  return (
    <div className="mt-8 space-y-4">
      {/* Product Item Preview */}
      <div className="flex items-center p-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
        <div className="h-16 w-16 flex-shrink-0 rounded-md overflow-hidden">
          <img 
            src={product.media_urls?.[0] || '/placeholder.svg'} 
            alt={product.name}
            className="h-full w-full object-cover"
          />
        </div>
        <div className="ml-4 flex-1">
          <h3 className="font-medium">{product.name}</h3>
          <p className="text-sm text-gray-500">
            {actualPrice.toFixed(2)} {product.currency}
          </p>
        </div>
        <ProductQuantitySelector 
          quantity={quantity}
          increment={incrementQuantity}
          decrement={decrementQuantity}
        />
      </div>
      
      {/* Order Summary */}
      <div className="space-y-2">
        <div className="flex justify-between text-sm">
          <span>Produit</span>
          <span>{totalPrice.toFixed(2)} {product.currency}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span>Livraison</span>
          <span>?</span>
        </div>
        <Separator className="my-2" />
        <div className="flex justify-between font-semibold">
          <span>Total</span>
          <span>{totalPrice.toFixed(2)} {product.currency}</span>
        </div>
      </div>
      
      {/* Submit Button */}
      <OrderFormSubmit 
        submitting={submitting} 
        disabled={!inStock}
        buttonColor={shopColor}
        buttonText={formId ? ctaButtonText : 'Commander الآن اطلب'}
      />
      
      {/* Add to Favorites */}
      <Button 
        type="button" 
        variant="ghost" 
        className="w-full mt-2"
      >
        <Heart className="w-4 h-4 mr-2" />
        Ajouter aux favoris
      </Button>
    </div>
  );
};

export default ProductOrderSummary;
